import React from 'react';
import "./Loader.css"; 


const Loader = () => {
  return (
   
   <div>Loading...</div>
  );
};
export default Loader;

